import React, { type ChangeEvent, type FC } from "react";

import { cn } from "@utilities/helper";

const InputSwitch: FC<{
  value: boolean;
  handleCheck?: (event: ChangeEvent<HTMLInputElement>) => void;
  title?: string;
  isDisabled?: boolean;
  isTitleOnRight?: boolean;
}> = ({
  value,
  handleCheck,
  title,
  isDisabled = false,
  isTitleOnRight = true,
}) => {
  return (
    <label
      className={cn("inline-flex items-center gap-3", {
        "flex-row": isTitleOnRight,
        "flex-row-reverse": !isTitleOnRight,
        "cursor-pointer": !isDisabled,
        "cursor-not-allowed opacity-50": isDisabled,
      })}
    >
      <input
        type="checkbox"
        onChange={handleCheck}
        checked={value}
        className="peer sr-only"
        disabled={isDisabled}
      />
      <div className="peer relative h-6 w-11 rounded-full bg-gray-200 transition duration-300 after:absolute after:start-[2px] after:top-[2px] after:size-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-primary-600 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary/80 peer-focus:ring-offset-1 rtl:peer-checked:after:-translate-x-full"></div>
      {title && (
        <span className="max-w-[calc(100%-3.5rem)] text-sm font-medium text-gray-900">
          {title}
        </span>
      )}
    </label>
  );
};

export default InputSwitch;
